import AsyncSelect from 'react-select/async';
import { useState, useRef } from 'react';
import { components } from 'react-select';
import { Tooltip } from '@gpstrackit/react-controls';
//Iconst
import SearchIcon from '@mui/icons-material/Search';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
//
import { searchData } from 'Core/common/redux/saga';

//Styles
import './searchInput.scss';

const Search = (props) => {
    const {
        graphqlFunction,
        graphqlConditions,
        placeholder,
        searchConditions,
        searchOptionValue,
        searchOptionLabel,
        value,
        onChange,
        customSearch,
        extraField,
        noSplit,
        splitNoDevices,
        checked,
        messages,
        isDisabled,
        style,
        noSearchOptions,
        openSearchCustomOptions,
        onlyEnterSearch,
        maxTags
    } = props;
    const searchInput = useRef(null);

    const [inputValue, setInputValue] = useState('');

    const loadOptions = (inputValue, callback) => {
        if (noSplit || !checked) {
            if (!inputValue) {
                console.log(" ")
                callback([])
                return
            }
            if (!noSearchOptions)
                searchData(
                    graphqlFunction,
                    graphqlConditions,
                    searchConditions,
                    searchOptionValue,
                    searchOptionLabel,
                    inputValue,
                    customSearch,
                    extraField,
                ).then((response) => {
                    if (response?.result) {
                        const { items } = response?.result
                        callback(items);
                    } else callback([]);
                })
            else callback([]);
        } else callback([]);
    };

    const handleInputChange = (newValue) => {
        const inputValue = newValue
        setInputValue(inputValue);
        return inputValue;
    };

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <SearchIcon onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onChange([...value], null, "autoSearch")
                }} />
            </components.DropdownIndicator>
        );
    };

    const MultiValue = (props) => {
        const { children } = props;

        const editHandler = (item) => {
            let currentValue = value
            let currentItem = item?.index;
            currentValue.splice(currentItem, 1);
            onChange([...currentValue], true);
            searchInput?.current?.props?.onInputChange(item?.children.trim());
            let messageBody = document.querySelector('.react-select-search__value-container');
            messageBody.scrollTop = messageBody.scrollHeight - messageBody.clientHeight;
        }

        return (
            <components.MultiValue {...props}>
                <Tooltip title={`Edit ${children}`}>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            editHandler(props)
                        }}
                    >
                        <span>{children}</span>
                    </div>
                </Tooltip>
            </components.MultiValue>
        );
    }

    const codes = ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"]

    const canAddMoreTags = (currentTags = []) => {
        if (!maxTags) return true;
        return currentTags.length < maxTags;
    };

    return (
        <div className={cx("search-input-container", (noSearchOptions && "search-input-container-hidden"))}>
            <AsyncSelect
                ref={searchInput}
                value={value}
                inputValue={inputValue}
                classNamePrefix="react-select-search"
                components={{ DropdownIndicator, MultiValue }}
                placeholder={placeholder || "Search"}
                loadOptions={loadOptions}
                onInputChange={(value) => handleInputChange(value)}
                isMulti
                isDisabled={isDisabled}
                getOptionLabel={e => {
                    if (openSearchCustomOptions) {
                        return openSearchCustomOptions(e)
                    } else {
                        if (extraField) {
                            return `${e[searchOptionLabel] || ''}  ${e?.company?.name ? `(${e?.company?.name})` : ''}`
                        } else {
                            return e[searchOptionLabel]
                        }
                    }
                }}
                getOptionValue={e => e[searchOptionValue]}
                isClearable
                cacheOptions
                defaultOptions
                onKeyDown={(e) => {
                    if (codes.includes(e.code)) {
                        e.preventDefault();
                    }
                    if ((e.code === "Enter" || e.code === "NumpadEnter") && inputValue && !checked) {
                        if (!canAddMoreTags(value)) {
                            e.preventDefault();
                            return;
                        }
                        e.preventDefault();
                        let currentitems = value;
                        let newItems = { [searchOptionValue]: inputValue.trim(), [searchOptionLabel]: inputValue }
                        currentitems.push(newItems);
                        let hash = {};
                        currentitems = currentitems.filter(o => hash[o[searchOptionValue]] ? false : hash[o[searchOptionValue]] = true);
                        if (!onlyEnterSearch)
                            onChange([...currentitems], null, e.code);
                        setInputValue('');
                        searchInput?.current?.props?.onMenuClose();
                    }
                    if ((e.code === "Enter" || e.code === "NumpadEnter") && inputValue && checked) {
                        if (!canAddMoreTags(value)) {
                            e.preventDefault();
                            return;
                        }
                        e.preventDefault();
                        let currentitems = value;
                        let newTags = splitNoDevices ? inputValue.split(/[,\r\n\t]+/).filter(element => element): inputValue.split(/[, ]+/).filter(element => element);
                        newTags.map((item, index) => {
                            currentitems.push({ [searchOptionValue]: `${item.trim()}-${uuidv4()}`, [searchOptionLabel]: item })
                        })
                        if (!onlyEnterSearch)
                            onChange([...currentitems], null, e.code);
                        setInputValue('');
                        searchInput?.current?.props?.onMenuClose();
                    }

                    if ((e.code === "Enter" || e.code === "NumpadEnter") && !inputValue && value.length > 0 && onlyEnterSearch) {
                        onChange([...value], null, e.code);
                        setInputValue('');
                        searchInput?.current?.props?.onMenuClose();
                    }
                }}
                onChange={(e, actionMeta) => {
                    if (actionMeta?.action === "remove-value") {
                        let removedValue = actionMeta.removedValue
                        let currentValue = Array.isArray(value) ? [...value] : [];
                        let deleteItem = currentValue?.findIndex((item) => item[searchOptionValue] === removedValue[searchOptionValue]);
                        if (deleteItem >= 0) {
                            currentValue.splice(deleteItem, 1);
                        }
                        onChange([...currentValue], null, actionMeta.action)
                    } else if (actionMeta?.action === "clear") {
                        onChange([], null, actionMeta.action)
                    } else {
                        if (!canAddMoreTags(value)) {
                            return;
                        }
                        onChange(e);
                    }
                }}
                onBlur={(e) => {
                    if (e.type == "blur" && inputValue?.length > 0) {
                        if (!canAddMoreTags(value)) {
                            setInputValue('');
                            return;
                        }
                        if (!checked) {
                            e.preventDefault();
                            let currentitems = value;
                            let newItems = { [searchOptionValue]: inputValue.trim(), [searchOptionLabel]: inputValue }
                            currentitems.push(newItems);
                            let hash = {};
                            currentitems = currentitems.filter(o => hash[o[searchOptionValue]] ? false : hash[o[searchOptionValue]] = true);
                            onChange([...currentitems]);
                            setInputValue('');
                            searchInput?.current?.props?.onMenuClose();
                        } else {
                            e.preventDefault();
                            let currentitems = value;
                            let newTags = inputValue.split(/[, ]+/).filter(element => element);
                            newTags.map((item, index) => {
                                currentitems.push({ [searchOptionValue]: `${item.trim()}-${uuidv4()}`, [searchOptionLabel]: item })
                            })
                            onChange([...currentitems]);
                            setInputValue('');
                            searchInput?.current?.props?.onMenuClose();
                        }
                    }
                }}
                noOptionsMessage={() => messages['no_options'] || 'No Options'}
            />
        </div>
    );
}
export default Search;